import { useEffect } from 'react';

export function useOverlaySync(
  textareaRef: React.RefObject<HTMLTextAreaElement>,
  overlayRef: React.RefObject<HTMLDivElement>
) {
  useEffect(() => {
    const textareaElement = textareaRef.current;
    const overlayElement = overlayRef.current;

    if (!textareaElement || !overlayElement) {
      return;
    }

    const syncOverlay = () => {
      overlayElement.scrollTop = textareaElement.scrollTop;
      overlayElement.scrollLeft = textareaElement.scrollLeft;
      overlayElement.style.height = `${textareaElement.offsetHeight}px`;

      const textareaStyle = window.getComputedStyle(textareaElement);
      const isScrollable =
        textareaStyle.overflowY === 'auto' ||
        textareaStyle.overflowY === 'scroll';

      if (isScrollable) {
        overlayElement.classList.add(
          'div-with-textarea-suggestions__overlay--scrollable'
        );
      } else {
        overlayElement.classList.remove(
          'div-with-textarea-suggestions__overlay--scrollable'
        );
      }
    };

    const resizeObserver = new ResizeObserver(syncOverlay);
    resizeObserver.observe(textareaElement);

    const mutationObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style'
        ) {
          syncOverlay();
        }
      });
    });
    mutationObserver.observe(textareaElement, {
      attributes: true,
      attributeFilter: ['style']
    });

    textareaElement.addEventListener('scroll', syncOverlay);
    syncOverlay();

    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
      textareaElement.removeEventListener('scroll', syncOverlay);
    };
  }, [textareaRef, overlayRef]);
}
